var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cover",class:_vm.coverClass,style:(_vm.style)},[_c('cover-holder',{attrs:{"src":_vm.coverUrl,"height":_vm.height,"radius":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }